import AuthRepository from './Auth/AuthRepository';
import EmployeeAccountRepository from './Account/EmployeeAccountRepository';
import GuardianAccountRepository from './Account/GuardianAccountRepository';
import SubaccountRepository from './Subaccount/SubaccountRepository';
import SubaccountDashboardRepository from './Subaccount/dashboard-repository';
import WalletRepository from "./Wallet/WalletRepository";
import WalletReportRepository from "./Wallet/WalletReportRepository";
import ImportRepository from "./Import/ImportRepository";
import ImportOperationRepository from "./Import/ImportOperationRepository";
import ImportSubaccountRepository from "./Import/ImportSubaccountRepository";
import ApplicationRepository from "./Application/ApplicationRepository";
import ApplicationMedicalExpenseReimbursementRepository from "./Application/MedicalExpenseReimbursementRepository";
import ApplicationFinancialSupportRepository from "./Application/FinancialSupportRepository";
import ApplicationChildLossSupportRepository from "./Application/ChildLossSupportRepository";
import ApplicationSocialSupportRepository from "./Application/SocialSupportRepository";
import ApplicationSettlementRepository from "./Application/SettlementRepository";
import MessageRepository from "./Message/MessageRepository";
import MessageAttachmentRepository from "./Message/MessageAttachmentRepository";
import MessageSearchRecipient from "./Message/MessageSearchRecipientRepository";
import SystemApplicationRepository from "./SystemApplication/SystemApplicationRepository";
import FundraisingRepository from "./fundraising/fundraising";
import InvitationRepository from "./Invitation/InvitationRepository";
import QuestionnaireRepository from "./Invitation/QuestionnaireRepository";
import BalanceOperationsReportRepository from "./Report/BalanceOperationsReport";
import InactiveSubaccountReportRepository from "./Report/InactiveSubaccountReport";
import ReleaseInfoRepository from "./ReleaseInfoRepository";

const repositories = {
  'AuthRepository': AuthRepository,
  'EmployeeAccountRepository': EmployeeAccountRepository,
  'GuardianAccountRepository': GuardianAccountRepository,
  'SubaccountRepository': SubaccountRepository,
  'SubaccountDashboardRepository': SubaccountDashboardRepository,
  'WalletRepository': WalletRepository,
  'WalletReportRepository': WalletReportRepository,
  'ImportRepository': ImportRepository,
  'ImportOperationRepository': ImportOperationRepository,
  'ImportSubaccountRepository': ImportSubaccountRepository,
  'ApplicationRepository': ApplicationRepository,
  'ApplicationMedicalExpenseReimbursementRepository': ApplicationMedicalExpenseReimbursementRepository,
  'ApplicationFinancialSupportRepository': ApplicationFinancialSupportRepository,
  'ApplicationChildLossSupportRepository': ApplicationChildLossSupportRepository,
  'ApplicationSocialSupportRepository': ApplicationSocialSupportRepository,
  'ApplicationSettlementRepository': ApplicationSettlementRepository,
  'MessageRepository': MessageRepository,
  'MessageAttachmentRepository': MessageAttachmentRepository,
  'MessageSearchRecipient': MessageSearchRecipient,
  'SystemApplicationRepository': SystemApplicationRepository,
  'FundraisingRepository': FundraisingRepository,
  'InvitationRepository': InvitationRepository,
  'QuestionnaireRepository': QuestionnaireRepository,
  'BalanceOperationsReportRepository': BalanceOperationsReportRepository,
  'InactiveSubaccountReportRepository': InactiveSubaccountReportRepository,
  'ReleaseInfoRepository': ReleaseInfoRepository,
};

export default {
  get: name => repositories[name]
};
